import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { FlexWrapperCenter } from '../styles/WrapperStyles';
import aisle_selected from '../assests/aisle_selected.png'
import aisle_unselected from '../assests/aisle_unselected.png'
import arike_selected from '../assests/arike_selected.png'
import arike_unselected from '../assests/arike_unselected.png'
import anbe_selected from '../assests/anbe_icon1.png'
import anbe_unselected from '../assests/anbe_icon2.png'
import neetho_selected from '../assests/neethoicon1.png'
import neetho_unselected from '../assests/neethoicon2.png'
import neene_selected from '../assests/neeneIcon1.png'
import neene_unselected from '../assests/neeneIcon2.png'
// import jalebi_selected from '../assests/jalebiIcon1.png'
// import jalebi_unselected from '../assests/jalebiIcon2.png'
// import heydil_selected from '../assests/heydil_icon1.png'
// import heydil_unselected from '../assests/heydil_icon2.png'
import { useNavigate } from "react-router-dom";
import { authorizedHttpPost } from "../api/httpCalls";
import urls from '../api/urls.json'
import Loader from "./Loader";
import { bannedTab, biosTab, curationTabs, imagesTab, memberTab, memberboardTab, moderatedTab, premiumTab, recheckTab, reportsTab, storiesTab, verifiedTab, baitProfilesTab, phoneNumbersTab, imageLabelsTab, sharingTab, eventTab, offlineEventAccessLevel } from "../access_levels";

const TextView = styled.div`
  margin-left: 30px;
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: #9b9b9b;
  text-align: left;
  ${props =>
        props.selected &&
        css`
      color: #464646;
      font-weight: 800;
      font-family: 'Gilory-Bold';
    `}
  cursor:pointer;
`;

const ImageParent = styled(FlexWrapperCenter)`
  margin-left: -20px;
`;

const BottomImage = styled.img`
  ${props =>
        props.aisle &&
        css`
      width: 81px;
      height: 81px;
    `}
  width:71px;
  height: 64px;
  cursor: pointer;
`;

const LogoutButton = styled.button`
  width: 94%;
  height: 58px;
  margin-top: 20px;
  border-radius: 29px;
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: #9b9b9b;
  background-color: #f8f8f8;
//   border-color: #f8f8f8;
`;

const LeftNav = ({ handleLeftNavAppChange, tabName }) => {
    const isIpad = window.innerWidth === 1180;
    const openNavValue = isIpad ? false : true;
    const [navTab, setNavTab] = useState(tabName);
    const [isNavOpen, setIsNavOpen] = useState(openNavValue);
    const [appName, setAppName] = useState(localStorage.getItem('appName'));
    const accessLevel = localStorage.getItem('accessLevel');
    const [isLoading, setIsLoading] = useState(false);
    let navigate = useNavigate();

    const openNav = () => {
        setIsNavOpen(true);
    };

    const closeNav = () => {
        setIsNavOpen(false);
    };

    const handleAppNameChange = (name) => {
        setAppName(name);
        localStorage.setItem('appName', name);
        handleLeftNavAppChange(name)
    };

    const handleLogOut = async () => {
        setIsLoading(true);
        await authorizedHttpPost(urls.LOGOUT, {})
        const appName = localStorage.getItem('appName');
        localStorage.clear();
        localStorage.setItem('appName', appName);
        setIsLoading(false);
        navigate('/login');
    }

    useEffect(() => {
        setNavTab(tabName);
    }, [tabName]);


    return (
        <div>
            {isLoading && <Loader />}
            <div >
                <span className="openNavIcon" onClick={openNav}>
                    &#9776;
                </span>
            </div>
            <div id="mySidenav" className={`sideNavStyles ${isNavOpen ? 'navOpenWidth' : 'navCloseWidth'}`}>
                <span onClick={closeNav} className="sidenavCloseBtn">
                    &times;
                </span>
                {
                    curationTabs.includes(accessLevel) && (
                        <>
                            <TextView selected={navTab === 'People' ? 'selected' : ''} onClick={() => navigate('/people')}>People</TextView>
                            <TextView selected={navTab === 'PeopleHNI' ? 'selected' : ''} onClick={() => navigate('/peopleHNI')}>People-HNI</TextView>
                            <TextView selected={navTab === 'Updates' ? 'selected' : ''} onClick={() => navigate('/updates')}>Updates</TextView>
                            <TextView selected={navTab === 'Feed' ? 'selected' : ''} onClick={() => navigate('/feed')}>Feed</TextView>
                            <TextView selected={navTab === 'Feed Auto Curated' ? 'selected' : ''} onClick={() => navigate('/feedAutoCurated')}>Feed Auto Curated</TextView>
                            <TextView selected={navTab === 'Autofeed' ? 'selected' : ''} onClick={() => navigate('/autofeed')}>Autofeed</TextView>
                            <TextView selected={navTab === 'Rate Images' ? 'selected' : ''} onClick={() => navigate('/rateimages')}>Rate Images</TextView>
                        </>
                    )
                }
                <div className="height20"></div>
                {
                    premiumTab.includes(accessLevel) && <TextView selected={navTab === 'Premium' ? 'selected' : ''} onClick={() => navigate('/premium')}>Premium</TextView>
                }
                {
                    recheckTab.includes(accessLevel) && <TextView selected={navTab === 'Recheck' ? 'selected' : ''} onClick={() => navigate('/recheck')}>Recheck</TextView>
                }
                {
                    verifiedTab.includes(accessLevel) && <TextView selected={navTab === 'Verified' ? 'selected' : ''} onClick={() => navigate('/verified')}>Verified</TextView>
                }
                {
                    imagesTab.includes(accessLevel) && <TextView selected={navTab === 'Images' ? 'selected' : ''} onClick={() => navigate('/images')}>Images</TextView>
                }
                {
                    curationTabs.includes(accessLevel) && ['Aisle', 'Arike'].includes(appName) && <TextView selected={navTab === 'Auto Updates' ? 'selected' : ''} onClick={() => navigate('/auto-updates-images')}>Auto Updates</TextView>
                }
                {
                    biosTab.includes(accessLevel) && <TextView selected={navTab === 'Bios' ? 'selected' : ''} onClick={() => navigate('/bios')}>Bios</TextView>
                }
                <div className="height20"></div>
                {
                    storiesTab.includes(accessLevel) && <TextView selected={navTab === 'Stories' ? 'selected' : ''} onClick={() => navigate('/stories')}>Stories</TextView>
                }
                {
                    memberTab.includes(accessLevel) && <TextView selected={navTab === 'Member' ? 'selected' : ''} onClick={() => navigate('/member')}>Member</TextView>
                }
                {
                    reportsTab.includes(accessLevel) && <TextView selected={navTab === 'Reports' ? 'selected' : ''} onClick={() => navigate('/reports')}>Reports</TextView>
                }
                {
                    moderatedTab.includes(accessLevel) && <TextView selected={navTab === 'Moderated' ? 'selected' : ''} onClick={() => navigate('/moderated')}>Moderated</TextView>
                }
                {
                    memberboardTab.includes(accessLevel) && <TextView selected={navTab === 'Memberboard' ? 'selected' : ''} onClick={() => navigate('/memberboard')}>Memberboard</TextView>
                }
                {
                    bannedTab.includes(accessLevel) && <TextView selected={navTab === 'Banned' ? 'selected' : ''} onClick={() => navigate('/banned')}>Banned</TextView>
                }
                {
                    baitProfilesTab.includes(accessLevel) && <TextView selected={navTab === 'Bait Profiles' ? 'selected' : ''} onClick={() => navigate('/baitprofiles')}>Bait Profiles</TextView>
                }
                {
                    phoneNumbersTab.includes(accessLevel) && <TextView selected={navTab === 'Phone Numbers' ? 'selected' : ''} onClick={() => navigate('/phonenumbers')}>Phone Numbers</TextView>
                }
                {
                    (imageLabelsTab.includes(accessLevel) && (appName === 'Aisle')) && <TextView selected={navTab === 'imageLabelling' ? 'selected' : ''} onClick={() => navigate('/imagelabel')}>Image Labels</TextView>
                }
                {
                    eventTab.includes(accessLevel) &&
                    <TextView selected={navTab === 'Event' ? 'selected' : ''} onClick={() => navigate('/event')}>Events</TextView>
                }
                {
                    sharingTab.includes(accessLevel) &&
                    <TextView selected={navTab === 'Ref Review' ? 'selected' : ''} onClick={() => navigate('/sharing')}>Ref Review</TextView>
                }
                <div className="height20"></div>
                {accessLevel !== offlineEventAccessLevel && (
                    <>
                        <ImageParent>
                            <BottomImage
                                onClick={() => handleAppNameChange('Aisle')}
                                src={appName === 'Aisle' ? aisle_selected : aisle_unselected}
                            />
                            <BottomImage
                                onClick={() => handleAppNameChange('Arike')}
                                src={appName === 'Arike' ? arike_selected : arike_unselected}
                            />
                        </ImageParent>
                        <ImageParent>
                            <BottomImage
                                onClick={() => handleAppNameChange('Anbe')}
                                src={appName === 'Anbe' ? anbe_selected : anbe_unselected}
                            />
                            {/* <BottomImage
                                onClick={() => handleAppNameChange('HeyDil')}
                                src={appName === 'HeyDil' ? heydil_selected : heydil_unselected}
                            /> */}
                        </ImageParent>
                        <ImageParent>
                            <BottomImage
                                onClick={() => handleAppNameChange('Neetho')}
                                src={appName === 'Neetho' ? neetho_selected : neetho_unselected}
                            />
                            <BottomImage
                                onClick={() => handleAppNameChange('Neene')}
                                src={appName === 'Neene' ? neene_selected : neene_unselected}
                            />
                        </ImageParent>
                    </>
                )}

                <LogoutButton onClick={handleLogOut}>Logout</LogoutButton>
            </div>
        </div>
    );
};

export default LeftNav;
